//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CursosAPI from '@/api/promotores/cursos.api'

export default {
  data() {
    return {
      cursos: [],
      loading: false,
      columns: [
        { name: 'curso', field: 'curso', label: 'Curso', sortable: true, required: true, align: 'left' },
        { name: 'promotor', field: 'usuario', label: 'Promotor', sortable: true, required: true, align: 'left' },
        { name: 'calificacion', field: 'calificacion', label: 'Calificación', },
        { name: 'status', field: 'status', label: 'Status', sortable: true, },
        { name: 'created_at', field: 'created_at', label: 'Creación', sortable: true, format: this.momentFromNow, },
      ],
      pagination: {
				sortBy: "created_at",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
			},
      per_page_options: [10, 20, 30, 40, 50, 100],
    }
  },

  mounted() {
    this.loadCursos();
  },

  methods: {
    async loadCursos(payload = {}) {
      const pagination = payload && payload.pagination ? payload.pagination : this.pagination

      try {
        this.loading = true
        const { data, ...response } = await CursosAPI.evaluaciones({
					page: pagination.page,
					limit: pagination.rowsPerPage,
					order: `${pagination.sortBy}:${pagination.descending ? "desc" : "asc"}`
				})

        this.pagination = {
					page: response.current_page,
					rowsPerPage: Number(response.per_page),
					rowsNumber: response.total,	
					sortBy: pagination.sortBy,
          descending: pagination.descending,
				}

        this.cursos = data
      } finally {
        this.loading = false
      }
    }
  }
}
